interface ScrollToOptions {
  alignTop?: boolean;
  offset?: number;
}

export default (
  target: Window | HTMLElement,
  options: ScrollToOptions = {}
) => {
  const settings = {
    alignTop: false,
    offset: 0,
    ...options,
  };
  if (typeof window.scrollTo === 'function') {
    if (target === window) {
      smoothScrollTo(0);
    } else {
      const element = target as HTMLElement;
      const adminbar = document.getElementById('adminbar');
      let top =
        element.getBoundingClientRect().top +
        (window.pageYOffset || document.documentElement.scrollTop);
      let offset = 0;

      if (adminbar) {
        offset = adminbar.offsetHeight;
      }

      if (settings.alignTop) {
        top = top - offset - settings.offset;
      } else {
        const heightDiff = window.innerHeight - offset - element.offsetHeight;
        if (heightDiff > 1) {
          top = top - heightDiff / 2;
        } else {
          top = top - offset;
        }
      }

      smoothScrollTo(top);
    }
  }
};

function lerp(v0: number, v1: number, t: number) {
  return v0 * (1 - t) + v1 * t;
}

function ease(v: number) {
  return 0.5 * (1 - Math.cos(Math.PI * v));
}

function smoothScrollTo(targetY: number, cb?: () => void) {
  let running = true;
  let frameId: number | null = null;

  function stop() {
    if (!running) return;
    running = false;

    if (frameId) {
      cancelAnimationFrame(frameId);
    }

    if (typeof cb === 'function') {
      cb();
    }
  }

  const startY = window.pageYOffset || document.documentElement.scrollTop;

  if (startY === targetY) {
    stop();
  }

  const startTime = Date.now();

  // const duration = Math.abs(targetY - startY) * 0.468;
  const duration = 468;

  function tick() {
    const elapsed = Date.now() - startTime;
    const fraction = elapsed / duration;

    window.scrollTo(0, lerp(startY, targetY, ease(fraction)));

    if (fraction >= 1) {
      stop();
    }

    if (running) {
      frameId = requestAnimationFrame(tick);
    }
  }

  tick();
}
